<h2 mat-dialog-title>Parâmetros do Relatório</h2>
<mat-dialog-content>
    <div *ngFor="let line of data.formattedParameters">
        <strong>{{ line.split(':')[0] }}</strong>: {{ line.split(':')[1] }}
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button style="background: blue; color: white;" mat-button mat-dialog-close>Fechar</button>
</mat-dialog-actions>